"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ObjectToStringComponent_1 = require("./ObjectToStringComponent");
exports.Stringify = ({ value, col, }) => {
    if (typeof value == "object")
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ObjectToStringComponent_1.ObjectToString, { value: value, col: col })));
    return react_1.default.createElement(react_1.default.Fragment, null, value);
};
//# sourceMappingURL=Stringify.js.map